import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { ImportCsvExcelTradesResponseModel, ImportMergeCsvExcelTradesResponseModel } from "@/features/accounts/csv-excel/services/import_trades_model";
import { ImportCsvExcelTradesService, ImportMergeCsvExcelTradesService } from "@/features/accounts/csv-excel/services/import_trades_service";
import { useInputValidation } from "@/shared/hooks/use-input-validation";


export const useImportCsvExcelTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const { validate } = useInputValidation("deleteOver4Bytes");
  const importCsvExcelTradesService = new ImportCsvExcelTradesService();
  const importMergeCsvExcelTradesService = new ImportMergeCsvExcelTradesService();
  
  // CSV/Excel明細更新
  const importCsvExcelTrades = async (
    accountGroupId: string,
    csvExcelAccountId: string,
    file: File,
    fileType: string,
    bankCode?: string,
    passbookName?: string,
  ): Promise<ImportCsvExcelTradesResponseModel | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await importCsvExcelTradesService.ImportCsvExcelTrades({
        account_group_id: accountGroupId,
        csvexcel_account_id: csvExcelAccountId,
        file: file,
        file_type: fileType,
        ...(bankCode && {bank_code: bankCode}),
        ...(passbookName && {passbook_name: validate(passbookName)}),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("importCsvExcelTrades:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // CSV/Excel明細更新
  const importMergeCsvExcelTrades = async (
    accountGroupId: string,
    csvExcelAccountId: string,
    file: File,
    fileType: string,
    bankCode?: string,
    passbookName?: string,
    balanceContinueState?: number,
    exclusionCondition?: number,
  ): Promise<ImportMergeCsvExcelTradesResponseModel | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await importMergeCsvExcelTradesService.ImportMergeCsvExcelTrades({
        account_group_id: accountGroupId,
        csvexcel_account_id: csvExcelAccountId,
        file: file,
        file_type: fileType,
        ...(bankCode && {bank_code: bankCode}),
        ...(passbookName && {passbook_name: validate(passbookName)}),
        ...(balanceContinueState && {balance_continue_state: balanceContinueState}),
        ...(exclusionCondition && {exclusion_condition: exclusionCondition}),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("importMergeCsvExcelTrades:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    importCsvExcelTrades: errorHandledAsync(importCsvExcelTrades, setError),
    importMergeCsvExcelTrades: errorHandledAsync(importMergeCsvExcelTrades, setError),
  };
};
